import { ImgHTMLAttributes, useState } from "react";
import placeholder from "../../../assets/playlist-placeholder.svg";

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> & {
  src?: string | null;
  alt: string;
};

const CoverImage = ({ src, alt, onError, ...props }: Props) => {
  const source = src?.trim() || placeholder;
  const [failedSource, setFailedSource] = useState<string>();
  const displayedSource = failedSource === source ? placeholder : source;

  return (
    <img
      {...props}
      src={displayedSource}
      alt={alt}
      onError={(event) => {
        if (displayedSource !== placeholder) setFailedSource(source);
        onError?.(event);
      }}
    />
  );
};

export default CoverImage;
